import axios from '../axios';
import config from '../../config';
const { eliteUrl, clubhubUrl } = config;
const elite = {
    getTeamsList(params) {
        return axios(eliteUrl + '/teamup-elite/teams', {
            method: 'GET',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 体测
    // 训练营体测球员个人列表
    teensCampUserPhysicalTestList(params) {
        return axios(eliteUrl + '/teamup-elite/physical/user_camp_physicalTest_list', {
            method: 'get',
            paramsToken: 'custom-token',
            params,
        });
    },
    // 球员信息 体测报告 体测下面的模板列表
    getUserPhysicalTestListTemplate(params) {
        return axios(eliteUrl + '/teamup-elite/physical/item_data/statistics_user_physical_test', {
            //体测列表
            method: 'get',
            paramsToken: 'custom-token',
            params,
        });
    },
    // START VIDEO
    // 获取视频容量
    getVideoCapacity(params) {
        return axios(eliteUrl + '/teamup-elite/uims/tenant_info', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
            tenant: false,
            handleTipsBySelf: true, // 自己处理返回值
        });
    },
    //视频列表
    getVideoList(params) {
        return axios(eliteUrl + '/teamup-elite/video/list', {
            method: 'GET',
            params,
            paramsToken: 'custom-token',
        });
    },

    getVideoInfo(params) {
        return axios(eliteUrl + '/teamup-elite/video', {
            //视频详情
            method: 'GET',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 获取周和年
    getWeekOfYear(params) {
        return axios(eliteUrl + '/teamup-elite/schedule/weekOfYear', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    getWeeks(params) {
        return axios(eliteUrl + '/teamup-elite/schedule/weeks', {
            // 向后台传周和年获取周视图
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    getWorkItemList(params) {
        //获取周视图工作项
        return axios(eliteUrl + '/teamup-elite/schedule/week', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    addWorkItemTask(data) {
        // 添加日主题
        return axios(eliteUrl + '/schedule/task', {
            method: 'post',
            data,
            paramsToken: 'custom-token',
        });
    },
    updateWorkItemTask(data) {
        //获取周视图工作项
        return axios(eliteUrl + '/schedule/task', {
            method: 'put',
            data,
            paramsToken: 'custom-token',
        });
    },
    deleteWorkItemTask(data) {
        // 删除日主题
        return axios(eliteUrl + '/schedule/task', {
            method: 'delete',
            data,
            paramsToken: 'custom-token',
            paramsType: 'FormData',
        });
    },
    getScheduleMonth(params) {
        //日程-月视图
        return axios(eliteUrl + '/teamup-elite/schedule/month', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    getScheduleYear(params) {
        //日程-年视图
        return axios(eliteUrl + '/teamup-elite/schedule/year', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    addScheduleYear(data) {
        //日程-年视图 -- 添加
        return axios(eliteUrl + '/schedule/year', {
            method: 'post',
            data,
            paramsToken: 'custom-token',
        });
    },
    updateScheduleYear(data) {
        //日程-年视图 -- 修改
        return axios(eliteUrl + '/schedule/year', {
            method: 'put',
            data,
            paramsToken: 'custom-token',
        });
    },
    // 日程 -- 日程职员打卡信息
    getAttendanceList(params) {
        return axios(eliteUrl + '/schedule/clockIn', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    //    总结信息获取
    summaryLists(params) {
        return axios(eliteUrl + '/teamup-elite/item/summary/list', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    getTeamList(params) {
        //获取所有球队列表
        return axios(eliteUrl + '/teamup-elite/teams', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 日程 -- 该日程所有事件列表
    getWorkItem_event_count(params) {
        return axios(eliteUrl + '/schedule/workItem_event_count', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 比赛球员数据
    getVideoWorkItemPlayers(params) {
        return axios(eliteUrl + '/schedule/workItem/players', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // END
    getPlayersList(data) {
        //获取球队内所有球员列表
        return axios(clubhubUrl + '/team/players', {
            method: 'post',
            data,
        });
    },
    //获取球队非球员信息--职员
    getStaffList(data) {
        return axios(clubhubUrl + '/team/staff', {
            method: 'post',
            data,
        });
    },
    getLatestReportTime(data) {
        return axios(`${eliteUrl}/teamup-elite/evaluation/latest-report-time`, {
            method: 'post',
            data,
        });
    },
    // 获取荣誉列表(最佳球员/最佳阵容)
    getTeensHonorList(params) {
        return axios(eliteUrl + '/teamup-elite/honor/list', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 新增/删除/修改荣誉
    teensCampHonor(data, method) {
        return axios(eliteUrl + '/honor', {
            method,
            params: method === ' get' ? data : '',
            data: method !== 'get' ? data : '',
            paramsToken: 'custom-token',
            paramsType: method === 'delete' ? 'FormData' : '',
        });
    },
    //获取球员基本信息
    getPlayersInfoMsg(params) {
        return axios(eliteUrl + '/user', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 查询第三方数据详情
    getThirdPartData(params) {
        return axios(eliteUrl + '/recommend/thirdPartData', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 删除第三方数据
    deleteThirdPartData(data) {
        return axios(eliteUrl + '/recommend/thirdPartData', {
            method: 'DELETE',
            data,
            paramsToken: 'custom-token',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
    // 更新第三方数据
    updateThirdPartData(data) {
        return axios(eliteUrl + '/recommend/thirdPartData', {
            method: 'PUT',
            data,
            paramsToken: 'custom-token',
        });
    },

    // 梯队->教育背景 (post:新增、delete:删除)
    schoolApi(method, data) {
        return axios(eliteUrl + '/user_school', {
            method,
            data,
            paramsToken: 'custom-token',
            paramsType: method === 'delete' ? 'FormData' : '',
        });
    },
    // 通用上传附件
    uploadAttachment(data) {
        return axios(eliteUrl + '/upload_file', {
            method: 'post',
            data,
            paramsToken: 'custom-token',
            timeout: 6000000,
        });
    },
    // 删除附件
    delAttachment(data) {
        return axios(eliteUrl + '/file', {
            method: 'delete',
            data,
            paramsToken: 'custom-token',
            paramsType: 'FormData',
        });
    },
    // 职员列表
    getStaff(params) {
        return axios(eliteUrl + '/management/user/staff/list', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 获取国家数据
    getCountries() {
        return axios('https://club-pub.oss-cn-beijing.aliyuncs.com/common/json/countries.json', {
            method: 'get',
            handleTipsBySelf: true,
        });
    },
    updateUser(data, params) {
        //更新用户信息
        return axios(eliteUrl + '/user', {
            method: 'put',
            data,
            params,
            paramsToken: 'custom-token',
        });
    },
    // 获取小程序二维码
    getShareQrcode(params) {
        return axios(eliteUrl + '/third_party/qrcode', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
            handleTipsBySelf: true, // 当返回的code不等于200时，自己处理错误，不用全局提示。默认为false。
            handleLoadingBySelf: true, // 不用弹loading，静默请求，或者组件内处理loading。默认为false。
            responseType: 'arraybuffer',
        });
    },

    // 梯队->职业信息 (post:新增、delete:删除)
    careerApi(method, data) {
        return axios(eliteUrl + '/user_career', {
            method,
            data,
            paramsToken: 'custom-token',
            paramsType: method === 'delete' ? 'FormData' : '',
        });
    },
    // 获取人员动态表单信息
    getUser_form_data(params) {
        return axios(eliteUrl + '/user_form_data', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 获取配置表单列表
    getUserFormList(params) {
        return axios(eliteUrl + '/userForm/list', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },

    // 伤病---------------------start
    // 伤病 - 获取最近伤病治疗记录
    getTreatRecords(params) {
        return axios(eliteUrl + '/injury/recently', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    //当前所有伤病信息
    injuryDetail(params) {
        return axios(eliteUrl + '/injury/current', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    //历史伤病
    injuryHistory(params) {
        return axios(eliteUrl + '/injury/history', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 查询某一个伤病
    getInjury(params) {
        //当前伤病信息
        return axios(eliteUrl + '/injury', {
            method: 'get',
            params,
            paramsToken: 'custom-token',
        });
    },
    // 伤病---------------------end
};
export default elite;
